import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { Icon } from 'antd';
import TeamsFollowed from './TeamsFollowed';
import LeaguesFollowed from './LeaguesFollowed';
import CategoriesFollowed from './CategoriesFollowed';

@observer(["web3Store", "eventStore", "ViewStore", "CategoriesStore", "TeamStore", "AdminStore", "UserStore", "AuthStore"])
class FollowList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }
    async componentDidMount() {
        let self = this;
        if (this.props.AuthStore.userAuth.auth !== undefined) {
            let authToken = this.props.AuthStore.userAuth.auth.accessToken;

            self.props.UserStore.updateUserBets(authToken);
        }
        setTimeout(() => {
            self.setState({ loading: false })
        }, 200);
    }



    render() {
        const { currentTab } = this.props;
        let content = ""

        if (currentTab == 1) {
            content =
                <div className="watchlist-followed-list-content">
                    <div className="watchlist-followed-list-content-cat-title">Teams</div>
                    <TeamsFollowed />
                    <div className="watchlist-followed-list-content-cat-title">Leagues</div>
                    <LeaguesFollowed />
                    <div className="watchlist-followed-list-content-cat-title">Sports</div>
                    <CategoriesFollowed />
                </div>
        } else if (currentTab == 2) {
            content =
                <div className="watchlist-followed-list-content">
                    <div className="watchlist-followed-list-content-cat-title">Teams</div>
                    <TeamsFollowed />
                </div>
        } else if (currentTab == 3) {
            content =
                <div className="watchlist-followed-list-content">
                    <div className="watchlist-followed-list-content-cat-title">Leagues</div>
                    <LeaguesFollowed />
                </div>
        } else if (currentTab == 4) {
            content =
                <div className="watchlist-followed-list-content">
                    <div className="watchlist-followed-list-content-cat-title">Sports</div>
                    <CategoriesFollowed />
                </div>
        }

        return (
            <div className="watchlist-followed-list">
                <div className="watchlist-followed-list-title">Follow List</div>
                {!this.state.loading ? content : <Icon type="loading" />}
            </div>
        );
    }
}

export default FollowList;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/followList/FollowList.js